var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:[_vm.routeClass, { 'repuagency': _vm.isRepuAgency, 'zensocial': _vm.isZenSocial, 'reputationhub': _vm.isReputationHub }],attrs:{"id":"app"}},[_c('router-view'),(_vm.loading)?_c('div',{staticClass:"loading-container"},[_c('b-spinner',{staticStyle:{"width":"80px","height":"80px"},attrs:{"variant":"primary"}})],1):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }